import React, { Component } from 'react';
import queryString from 'query-string';
import { get,post } from '../utils/request';

class CourseReCom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      endReCourse: false,
    }
  }
  componentDidMount () {

    this.getReCourse();
  }
  getReCourse = () => {
    post('/fancube/apply/success-recommend/',{
      "code": this.props.acid
    })
    .then(res => {
      if (res.code === 200) {
        this.setState({
          reCourse: res.data.recommends,
          endReCourse: true
        })
      }
    })
  }
  render() {
    return (
      <div className="course-recommend-wrapper need-clear">
        <div className="login-title">
          其他课堂推荐
        </div>
        <div className="course-re-content">
        {
          this.state.endReCourse &&
          <div className="active-wrap">
            <ul className="active-list default-ul-style">
              {
                this.state.reCourse.map(val => {
                  return (
                    <li key={val.url}>
                      <a href={val.url} target="_blank"  rel="noopener noreferrer">
                        <img src={`${val.img_url}-website.events.list`} alt="课堂图" />
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
          }
        </div>
      </div>
    )
  }
}

export default CourseReCom;
